<script>
  export let classes;
  export let color;
</script>

<div class={classes}>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2060_5798)">
      <path
        d="M1.62245 4.61853L3.32945 5.07592"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.3474 8.72556L3.59701 7.47595"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.61841 1.62244L5.0758 3.32944"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.72546 2.34753L7.47585 3.59715"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.7535 6.41862C5.60082 8.05247 6.10872 11.3669 8.35398 14.067C8.70202 14.4854 9.27359 14.4467 9.49154 13.9478C9.73803 13.3837 9.99695 12.6452 10.2058 12.0086L12.2014 14.0043C12.6992 14.5021 13.5062 14.5021 14.004 14.0043C14.5018 13.5065 14.5018 12.6995 14.0041 12.2017L12.0084 10.2059C12.6451 9.99711 13.3836 9.73816 13.9477 9.49167C14.4465 9.27372 14.4853 8.70215 14.0667 8.35411C11.3667 6.10886 8.05232 5.60096 6.41848 5.75364C6.06091 5.78706 5.78692 6.06105 5.7535 6.41862Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2060_5798">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</div>
